import { ChevronLeft, ChevronRight } from 'lucide-react'

import { Button } from './ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'

const DEFAULT_PAGE_SIZES = [25, 50, 100]

export function TablePagination({
  pageIndex,
  pageCount,
  pageSize,
  onPageSizeChange,
  onPreviousPage,
  onNextPage,
  canPreviousPage,
  canNextPage,
  pageSizes = DEFAULT_PAGE_SIZES,
}: {
  pageIndex: number
  pageCount: number
  pageSize: number
  onPageSizeChange: (pageSize: number) => void
  onPreviousPage: () => void
  onNextPage: () => void
  canPreviousPage: boolean
  canNextPage: boolean
  pageSizes?: number[]
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>Na stronie</span>
        <Select
          items={Object.fromEntries(
            pageSizes.map((pageSize) => [String(pageSize), String(pageSize)]),
          )}
          value={String(pageSize)}
          onValueChange={(value) => value && onPageSizeChange(Number(value))}
        >
          <SelectTrigger className="h-8 w-20">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {pageSizes.map((pageSize) => (
              <SelectItem key={pageSize} value={String(pageSize)}>
                {pageSize}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <span>
          Strona {pageCount === 0 ? 0 : pageIndex + 1} z {pageCount}
        </span>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label="Poprzednia strona"
          disabled={!canPreviousPage}
          onClick={onPreviousPage}
        >
          <ChevronLeft />
        </Button>
        <Button
          variant="outline"
          size="icon-sm"
          aria-label="Nastepna strona"
          disabled={!canNextPage}
          onClick={onNextPage}
        >
          <ChevronRight />
        </Button>
      </div>
    </div>
  )
}
